<onyx-information-heading>
  {{ 'labels.canceled' | translate }}
</onyx-information-heading>

<div class="container">
  <onyx-data-widget supheading="labels.reason">
    <ng-container heading>
      {{
        `${DictionaryCode.ORDER_CANCELLATION_REASON}.${cancellation().reason}`
          | translate
      }}
    </ng-container>

    <span>
      {{ 'labels.note' | translate }}

      <span class="note">
        @if (cancellation().note; as note) {
          {{ note }}
        } @else {
          -
        }
      </span>
    </span>
  </onyx-data-widget>

  <onyx-data-widget [supheading]="`${I18N}.appealCharge`">
    <ng-container heading>
      {{
        `${DictionaryCode.ORDER_CANCELLATION_CHARGE_PARTY}.${cancellation().chargeParty}`
          | translate
      }}
    </ng-container>

    <span>
      {{ 'labels.penalty' | translate }}

      <span class="amount">
        @if (cancellation().chargeAmount; as amount) {
          {{ amount | onyxAmount: 'value' : false : 0 }}
        } @else {
          -
        }
      </span>
    </span>
  </onyx-data-widget>
</div>
